import React from 'react';
import styles from './styles/LoadingDots.module.scss';

const LoadingDots = () => {
  return <div className={styles.dots}></div>;
};

export default LoadingDots;
